// src/tattoo/TattooShareInit.jsx
import { useEffect } from "react";
import { openLeft, editLayer } from "./state";

function getHashParams() {
  const raw = (window.location.hash || "").replace(/^#/, "");
  return new URLSearchParams(raw);
}

export default function TattooShareInit() {
  useEffect(() => {
    const params = getHashParams();
    const layerId = params.get("layer") || params.get("l");
    const panel = params.get("panel");

    const t = setTimeout(() => {
      if (layerId) {
        try { openLeft(); } catch {}
        try { editLayer(layerId); } catch {}
        try {
          window.dispatchEvent(
            new CustomEvent("comments:open", { detail: { layerId } })
          );
        } catch {}
      } else if (panel === "comments") {
        try { openLeft(); } catch {}
        try {
          window.dispatchEvent(
            new CustomEvent("comments:open", { detail: {} })
          );
        } catch {}
      }
    }, 0);

    return () => clearTimeout(t);
  }, []);

  return null;
}